import React from 'react';
import { useContent } from '../cms/content.js';

export default function Events() {
  const cms = useContent();
  return (
    <section
      style={{
        position: 'relative',
        zIndex: 10,
        background: '#0a0a0b',
        borderTop: '1px solid rgba(201,168,106,0.14)',
        padding: '130px 32px'
      }}
    >
      <div style={{ maxWidth: '1180px', margin: '0 auto' }}>
        <div data-reveal="" style={{ textAlign: 'center', marginBottom: '62px' }}>
          <div
            style={{
              font: "500 12px/1 'JetBrains Mono',monospace",
              letterSpacing: '0.34em',
              textTransform: 'uppercase',
              color: '#c9a86a',
              marginBottom: '24px'
            }}
          >
            {cms.events.eyebrow}
          </div>
          <h2
            style={{
              margin: '0 auto',
              fontFamily: "'Cormorant',serif",
              fontWeight: 400,
              fontSize: 'clamp(38px,5vw,68px)',
              lineHeight: '1.0',
              color: '#f5f0e6'
            }}
          >
            {cms.events.heading}
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '18px' }}>
          {(cms.events.items || []).map((item, index) => (
            <div key={index} data-reveal="">
              <div className="kny-photo" style={{ border: '1px solid rgba(201,168,106,0.18)' }}>
                <image-slot
                  id={`kny-evt-${index + 1}`}
                  className="kny-img"
                  src={item.image}
                  shape="rounded"
                  radius="2"
                  placeholder={item.placeholder}
                  style={{ display: 'block', width: '100%', height: '360px' }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'baseline',
                  marginTop: '16px'
                }}
              >
                <span style={{ fontFamily: "'Cormorant',serif", fontSize: '23px', color: '#f5f0e6' }}>
                  {item.title}
                </span>
                <span
                  style={{
                    font: "500 10px/1 'JetBrains Mono',monospace",
                    letterSpacing: '0.14em',
                    color: '#6f6a60'
                  }}
                >
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
